import Constants from '../definitions/constants';
import EngineFunctionsDefinition from '../definitions/engineFunctionsDefinition';
import JavascriptUtilsTooling from '../tooling/javascriptUtilsTooling';
import { intl } from '../locales/localesConfig';

const FormulaUtilsTooling = {
  getFormulaAdditionalDataFromParentId: (formulaObject, parentId) => {
    let additionalData = {};
    FormulaUtilsTooling.getFormulaArrayFromParentId(formulaObject, parentId, additionalData);
    return additionalData;
  },
  getFormulaArrayFromParentId: (formulaObject, parentId, additionalReturnData = null) => {
    let path = parentId.split("-").filter(i => i);
    let formulaArray = formulaObject.formulaArray;
    for(let i=0; i<path.length; i++) {
      let coordinate = path[i].split("_");
      let arrayIndex = coordinate[0];
      let childIndex = coordinate[1];
      if(arrayIndex<formulaArray.length && ("childs" in formulaArray[arrayIndex]) && 
          childIndex<formulaArray[arrayIndex].childs.length && ("content" in formulaArray[arrayIndex].childs[childIndex])) {
        let transitionEntity = formulaArray[arrayIndex];
        if(additionalReturnData && transitionEntity.type=="Function" && (transitionEntity.name==EngineFunctionsDefinition.functionsList.SUMX.code || transitionEntity.name==EngineFunctionsDefinition.functionsList.REDUCEX.code) && transitionEntity.childs[0].content.length>0) {
          let metricEntity = transitionEntity.childs[0].content[0];
          if(metricEntity.type == "Function" && metricEntity.name==EngineFunctionsDefinition.functionsList.CALENDAR.code) {
            additionalReturnData.sumxDefaultMetricName = !additionalReturnData.sumxDefaultMetricName ? intl.formatMessage({id: "calendarAdmin.calendarMetricName"}) : null;
          }
          else {
            additionalReturnData.sumxDefaultMetricName = !additionalReturnData.sumxDefaultMetricName ? metricEntity.name : null;
          }         
          additionalReturnData.inSumX = true;
        }
        formulaArray = formulaArray[arrayIndex].childs[childIndex].content;
      }
      else {
        return null;
      }
    }
    return formulaArray;
  },
  // if position is -1 to the left of index, 1 to the right and 0 replace
  editFormulaObject: (formulaObject, parentId, index, position, valueToAdd, contextInfo = {}) => {
    let newFormulaObject = JavascriptUtilsTooling.deepCopy(formulaObject);
    delete newFormulaObject.invalid
    let additionalReturnData = {};
    let formulaArray = FormulaUtilsTooling.getFormulaArrayFromParentId(newFormulaObject, parentId, additionalReturnData);
    if(formulaArray==null) {
      return newFormulaObject;
    }
    for(let i=0; i<=formulaArray.length; i++) {
      if(i==index) {
        let actualObjectPosition = i==formulaArray.length ? null : formulaArray[i];
        let indexToAdd = position == 1 ? i + 1 : i;
        let replace = (position == 0 && typeof actualObjectPosition === "string") ? 1 : 0;
        let objectToReplace = FormulaUtilsTooling.getObjectToAdd(valueToAdd, additionalReturnData, contextInfo);
        if(Array.isArray(objectToReplace)) {
          formulaArray.splice(indexToAdd, replace, ...objectToReplace);
        }
        else {
          formulaArray.splice(indexToAdd, replace, objectToReplace);  
        }        
        break;
      }
    }
    return newFormulaObject;
  },
  getObjectToAdd: (valueToAdd, additionalData = null, contextInfo = {}) => {
    if(typeof valueToAdd === 'string') {
      return valueToAdd.split("");
    }
    else {
      let newObject = {};
      newObject.name = valueToAdd.name;
      newObject.type = valueToAdd.entityType;
      newObject.collapse = false;
      newObject.childs = [];
      if(valueToAdd.entityType == "Metric") {
        newObject.final_type = valueToAdd.final_type;
        newObject.reducer = (valueToAdd.final_type == Constants.selectKeys.metric.dataType.STRING || valueToAdd.final_type == Constants.selectKeys.metric.dataType.DATE || valueToAdd.final_type == Constants.selectKeys.metric.dataType.DATETIME || valueToAdd.final_type == Constants.selectKeys.metric.dataType.TIME) ? 
          Constants.selectKeys.formulaEditor.metricReducerTypes.UNIQUE :
          Constants.selectKeys.formulaEditor.metricReducerTypes.AVERAGE;
        newObject.object_definition = null;
        newObject.metric_type = valueToAdd.metric_type;
        newObject.childs = valueToAdd.dimension_hash.map(dimension_item => {
          return {
            id: dimension_item.id,
            name: dimension_item.name,
            content: null,
            type: (valueToAdd.metric_type == Constants.metricAdmin.metricType.DYNAMIC && dimension_item.is_period_dimension && contextInfo.loadMetricModeActive) ? 
              Constants.selectKeys.formulaEditor.metricParamTypes.EMPTY : "" 
          }
        });
        newObject.childs.push({
          id: null,
          name: valueToAdd.virtual_calculation ? 
            intl.formatMessage({id: "polynomialAdmin.formulaEditor.entityEditor.calculationParamValueLabel"}) :
            intl.formatMessage({id: "polynomialAdmin.formulaEditor.entityEditor.paramValueLabel"}),
          content: null,
          type: Constants.selectKeys.formulaEditor.metricParamTypes.EMPTY,
          is_value_param: true,
          validation_dimension_id: valueToAdd.validation_dimension_id
        });
        if(valueToAdd.virtual_calculation) {
          newObject.virtual_calculation = true;
        }
        newObject.object_definition = valueToAdd.object_definition;
      }
      else if(valueToAdd.entityType == "Polynomial") {        
        newObject.options = {};
        if(valueToAdd.is_table) {          
          newObject.childs = valueToAdd.table_params_hash.map(param_item => {
            return {
              dimension_id: param_item.dimension_id,
              name: param_item.name,
              content: null,
              type: ""
            }
          });
        }
      }
      else if(valueToAdd.entityType == "Function") {
        newObject.name = valueToAdd.id;
        let functionDefinition = (valueToAdd.id in EngineFunctionsDefinition.functionsList) ? EngineFunctionsDefinition.functionsList[valueToAdd.id] : null;
        if(functionDefinition) {
          newObject.childs = functionDefinition.params.filter(param_item => !param_item.conditional).map(param_item => {
            let editable = (param_item.type==Constants.formulaEditor.functionParamsTypes.metricsList ||
              param_item.type==Constants.formulaEditor.functionParamsTypes.metricDimensionsOrValueList ||
              param_item.type==Constants.formulaEditor.functionParamsTypes.metricObjectAttributesList ||
              param_item.type==Constants.formulaEditor.functionParamsTypes.string);
            let content = [];
            if(param_item.type == Constants.formulaEditor.functionParamsTypes.logicalFormula) {
              content = [FormulaUtilsTooling.createNewLogicalObject()];
            }
            else if(param_item.type == Constants.formulaEditor.functionParamsTypes.logicalDimensionFormula) {
              content = [FormulaUtilsTooling.createNewLogicalDimensionObject()];
            }
            return {
              content: content,
              type: editable ? Constants.selectKeys.formulaEditor.formulaParamTypes.STRING : Constants.selectKeys.formulaEditor.formulaParamTypes.FREE
            }
          });
          if(additionalData && additionalData.sumxDefaultMetricName && (valueToAdd.id == EngineFunctionsDefinition.functionsList.COLX.code || valueToAdd.id == EngineFunctionsDefinition.functionsList.PRECOLX.code || valueToAdd.id == EngineFunctionsDefinition.functionsList.INFOX.code)) {
            newObject.childs[0].content = [additionalData.sumxDefaultMetricName];
          }
          if(valueToAdd.id == EngineFunctionsDefinition.functionsList.DIMENSIONRANGE.code){
            newObject.childs[0].content = [Constants.selectKeys.formulaEditor.dimensionRangeOperatorTypes.AND];
          }   
        }
      }
      if("is_table" in valueToAdd) {        
        newObject.is_table = valueToAdd.is_table;
      }
      return newObject;
    }
  },
  getParentId: (grandParentId, parentIndex, paramIndex) => {
    let newPath = grandParentId;
    newPath += parentIndex + "_" + paramIndex + "-";
    return newPath;
  },
  getRootId: () => {
    return "";
  },
  getEditingEntity: (formulaObject, entityId, remove = false, extraOptionsReturn = false) => {
    if(formulaObject==null || entityId==null) {
      return null;
    }
    let path = entityId.split("-");
    let entity = null;
    let formulaArrayParent = formulaObject;
    let formulaArray = formulaObject.formulaArray;
    let sumxParentParam0 = false;
    let loadMetricParentParam0 = false;
    let metricParent = false;
    let polynomialParent = false;
    let parentDimensionId = null;
    let extraOptionsReturnObject = {};
    extraOptionsReturnObject.options = {};
    extraOptionsReturnObject.options.sumxMetricsNamesOptions = [{value: "", label: ""}];
    for(let i=0; i<path.length; i++) {
      let coordinate = path[i].split("_");
      if(coordinate.length == 1 && formulaArray) {
        let entityIndex = coordinate[0];
        if(entityIndex<formulaArray.length) {
          entity = formulaArray[entityIndex];
          extraOptionsReturnObject.entity = entity;
          if((sumxParentParam0 || (formulaObject.formula_type==Constants.formulaEditor.formulaTypes.METRIC && path.length==1)) && entity.type=="Metric" && extraOptionsReturn) {
            extraOptionsReturnObject.options.metricBehaviour = Constants.formulaEditor.metricBehaviour.ITERABLE_METRIC;
          }
          if(loadMetricParentParam0 && entity.type=="Metric" && extraOptionsReturn) {
            extraOptionsReturnObject.options.metricBehaviour = Constants.formulaEditor.metricBehaviour.LOADABLE_METRIC;
          }
          if((metricParent || polynomialParent) && entity.type=="Function" && entity.name==EngineFunctionsDefinition.functionsList.IN_METRIC_INCLUDES_FAKE_FUNCTION.code && extraOptionsReturn) {
            extraOptionsReturnObject.options.dimension_id = parentDimensionId;
          }
          if(remove) {
            if(entity.type=="Function" && entity.name == Constants.formulaEditor.markCode) {
              let childsToReplace = entity.childs[0].content;
              if("formulaArray" in formulaArrayParent) {
                formulaArrayParent.formulaArray.splice(entityIndex, 1, ...childsToReplace);
              }
              else {
                formulaArrayParent.content.splice(entityIndex, 1, ...childsToReplace);
              }              
            }
            else {
              delete formulaArray[entityIndex];
              if("formulaArray" in formulaArrayParent) {
                formulaArrayParent.formulaArray = formulaArray.filter(item => item);
              }
              else {
                formulaArrayParent.content = formulaArray.filter(item => item);
              }
            }
          }
          if(extraOptionsReturn) {
            return extraOptionsReturnObject;
          }
          return entity;
        }
        else {
          return null;
        }        
      }
      else {
        let arrayIndex = coordinate[0];
        let childIndex = coordinate[1];
        if(arrayIndex<formulaArray.length && ("childs" in formulaArray[arrayIndex]) && 
            childIndex<formulaArray[arrayIndex].childs.length && ("content" in formulaArray[arrayIndex].childs[childIndex])) {
          let transitionEntity = formulaArray[arrayIndex];
          if(transitionEntity.type=="Function" && (transitionEntity.name==EngineFunctionsDefinition.functionsList.SUMX.code || transitionEntity.name==EngineFunctionsDefinition.functionsList.REDUCEX.code) && transitionEntity.childs[0].content.length>0) {
            let metricEntity = transitionEntity.childs[0].content[0];
            if(metricEntity.type == "Function" && metricEntity.name==EngineFunctionsDefinition.functionsList.CALENDAR.code) {
              let calendarMetricName = intl.formatMessage({id: "calendarAdmin.calendarMetricName"});
              extraOptionsReturnObject.options.sumxMetricsNamesOptions.push({value: calendarMetricName, label: calendarMetricName});
            }
            else if(metricEntity.virtual_calculation && metricEntity.childs) {
              extraOptionsReturnObject.options.sumxMetricsNamesOptions.push({
                value: metricEntity.name, label: metricEntity.name, virtual_calculation: true,
                dimensionsNames: metricEntity.childs.filter(metricChild => metricChild.id).map(metricChild => metricChild.name)
              });
            }
            else {
              extraOptionsReturnObject.options.sumxMetricsNamesOptions.push({value: metricEntity.name, label: metricEntity.name});
            }
          }
          if(transitionEntity.type=="Function" && (transitionEntity.name==EngineFunctionsDefinition.functionsList.SUMX.code || transitionEntity.name==EngineFunctionsDefinition.functionsList.REDUCEX.code) && childIndex==0) {
            sumxParentParam0 = true;
          }
          else {
            sumxParentParam0 = false;
          }
          if(transitionEntity.type=="Function" && transitionEntity.name==EngineFunctionsDefinition.functionsList.LOADMETRIC.code && childIndex==0) {
            loadMetricParentParam0 = true;
          }
          else {
            loadMetricParentParam0 = false;
          }
          metricParent = transitionEntity.type=="Metric" ? true : false;
          polynomialParent = transitionEntity.type=="Polynomial" ? true : false;
          parentDimensionId = (transitionEntity.type=="Metric" || transitionEntity.type=="Polynomial") ? (transitionEntity.childs[childIndex].is_value_param ? transitionEntity.childs[childIndex].validation_dimension_id : transitionEntity.childs[childIndex].id) : null;
          formulaArrayParent = transitionEntity.childs[childIndex];
          formulaArray = transitionEntity.childs[childIndex].content;
        }
        else {
          return null;
        }
      }
    }
    return null;
  },
  editFormulaObjectEntityData: (formulaObject, entityId, path, data) => {
    let newFormulaObject = JavascriptUtilsTooling.deepCopy(formulaObject);
    delete newFormulaObject.invalid
    let entityToEdit = FormulaUtilsTooling.getEditingEntity(newFormulaObject, entityId);    
    if(entityToEdit) {
      if(entityToEdit.type=="Polynomial" && path=="options") {
        if(data.value == "" && (data.name in entityToEdit.options)) {
          delete entityToEdit.options[data.name];
        }
        else {
          entityToEdit.options[data.name] = data.value;
        }
      }
      else if(entityToEdit.type=="Metric" && path=="order_by_descriptor") {
        let new_order_by_descriptor = entityToEdit[path] ? JavascriptUtilsTooling.deepCopy(entityToEdit[path]) : [];
        if(data.isDelete) { 
          delete new_order_by_descriptor[data.index];
          new_order_by_descriptor = new_order_by_descriptor.filter(item => item);
        } else if(data.isEdit) {
          new_order_by_descriptor[data.index] = data.value;
        } else {
          new_order_by_descriptor.push(data.value);
        }    
        entityToEdit[path] = new_order_by_descriptor;
      }
      else if(entityToEdit.type=="Polynomial" || entityToEdit.type=="Metric" || entityToEdit.type=="Function") {
        if(path=="childs") {
          let targetChild = {};
          let isNew = false;
          if(data.isEdit && data.index<entityToEdit.childs.length) {
            targetChild = entityToEdit.childs[data.index];
          }
          else if(data.isDelete && data.index<entityToEdit.childs.length) {
            delete entityToEdit.childs[data.index];
            entityToEdit.childs = entityToEdit.childs.filter(item => item);
          }
          else {
            isNew = true;
            entityToEdit.childs.push(targetChild);
          }         
          
          if(!data.isDelete) {
            if(entityToEdit.type=="Polynomial" && !entityToEdit.is_table) {
              targetChild.id = data.value.dimension_id;
              targetChild.name = data.value.dimension_name;
            }
            else if(entityToEdit.type=="Polynomial" && entityToEdit.is_table) {
              targetChild.name = data.value.param_name;            
            }    
            else if(entityToEdit.type=="Metric" && entityToEdit.virtual_calculation && !data.value.is_value_param) {
              targetChild.id = data.value.dimension_id;
              targetChild.name = data.value.dimension_name;              
            }

            if(data.value.type == Constants.selectKeys.formulaEditor.formulaParamTypes.FREE && 
               data.value.param_type == Constants.formulaEditor.functionParamsTypes.logicalFormula) {
              if(isNew) {
                targetChild.content = [FormulaUtilsTooling.createNewLogicalObject()];
              }
              else {
                if(targetChild.content[0].is_function != data.value.is_logic_function && !data.value.is_logic_function) {
                  let tempObject = FormulaUtilsTooling.createNewLogicalObject();
                  targetChild.content[0].childs = tempObject.childs;
                }
                else if(targetChild.content[0].is_function != data.value.is_logic_function && data.value.is_logic_function) {
                  targetChild.content[0].childs = [{
                    content: [],
                    type: Constants.selectKeys.formulaEditor.formulaParamTypes.FREE
                  }];
                }                
                if(!data.value.is_logic_function && data.value.value != targetChild.content[0].comparator && data.value.value == Constants.selectKeys.formulaEditor.logicalComparators.oneterm) {
                  targetChild.content[0].childs = [targetChild.content[0].childs[0]]
                }
                else if(!data.value.is_logic_function && data.value.value != targetChild.content[0].comparator && data.value.value != Constants.selectKeys.formulaEditor.logicalComparators.oneterm) {
                  let tempObject = FormulaUtilsTooling.createNewLogicalObject();
                  targetChild.content[0].childs[1] = tempObject.childs[1];
                }
                
                targetChild.content[0].is_function = data.value.is_logic_function;
                targetChild.content[0].comparator = data.value.is_logic_function ? Constants.selectKeys.formulaEditor.logicalComparators.equal : data.value.value;
                if(!targetChild.content[0].is_function && targetChild.content[0].childs.length==2) {
                  targetChild.content[0].childs[1].type = data.value.right_logical_override_string ? Constants.selectKeys.formulaEditor.formulaParamTypes.STRING : Constants.selectKeys.formulaEditor.formulaParamTypes.FREE;
                  targetChild.content[0].childs[1].content = data.value.right_logical_override_string ? [data.value.right_logical_override_string] : [];
                }
              }
            }
            else if(data.value.type == Constants.selectKeys.formulaEditor.formulaParamTypes.FREE && 
              data.value.param_type == Constants.formulaEditor.functionParamsTypes.logicalDimensionFormula) {
             if(isNew) {
               targetChild.content = [FormulaUtilsTooling.createNewLogicalDimensionObject()];
             }
             else {
               if(targetChild.content[0].is_function != data.value.is_logic_function && !data.value.is_logic_function) {
                 let tempObject = FormulaUtilsTooling.createNewLogicalDimensionObject();
                 targetChild.content[0].childs = tempObject.childs;
               }
               else if(targetChild.content[0].is_function != data.value.is_logic_function && data.value.is_logic_function) {
                 targetChild.content[0].childs = [{
                   content: [],
                   type: Constants.selectKeys.formulaEditor.formulaParamTypes.FREE
                 }];
               }                
               if(!data.value.is_logic_function && data.value.value != targetChild.content[0].comparator && data.value.value == Constants.selectKeys.formulaEditor.logicalComparators.oneterm) {
                 targetChild.content[0].childs = [targetChild.content[0].childs[0]]
               }
               else if(!data.value.is_logic_function && data.value.value != targetChild.content[0].comparator && data.value.value != Constants.selectKeys.formulaEditor.logicalComparators.oneterm) {
                 let tempObject = FormulaUtilsTooling.createNewLogicalDimensionObject();
                 targetChild.content[0].childs[1] = tempObject.childs[1];
               }
               
               targetChild.content[0].is_function = data.value.is_logic_function;
               targetChild.content[0].comparator = data.value.is_logic_function ? Constants.selectKeys.formulaEditor.logicalComparators.equal : data.value.value;
               if(!targetChild.content[0].is_function && targetChild.content[0].childs.length==2) {
                 targetChild.content[0].childs[1].type = data.value.right_logical_override_string ? Constants.selectKeys.formulaEditor.formulaParamTypes.STRING : Constants.selectKeys.formulaEditor.formulaParamTypes.FREE;
                 targetChild.content[0].childs[1].content = data.value.right_logical_override_string ? [data.value.right_logical_override_string] : [];
               }
             }
           }
            else if(data.value.type == Constants.selectKeys.formulaEditor.formulaParamTypes.FREE && data.value.type!=targetChild.type) {
              targetChild.content = [];
            }
            else if(data.value.param_type == Constants.formulaEditor.functionParamsTypes.metricsList) {
              targetChild.content = [data.value.value];
              if(entityToEdit.childs.length>1 && entityToEdit.name != EngineFunctionsDefinition.functionsList.INFOX.code) {                
                let dimensionOrValueChild = entityToEdit.childs[1];
                let newChilds = [];
                dimensionOrValueChild.content = [];
                dimensionOrValueChild.type = Constants.selectKeys.formulaEditor.formulaParamTypes.STRING;
                newChilds.push(targetChild);
                newChilds.push(dimensionOrValueChild);
                entityToEdit.childs = newChilds;
              }
            }
            else if(data.value.param_type == Constants.formulaEditor.functionParamsTypes.metricDimensionsOrValueList) {
              targetChild.content = [data.value.value];
              targetChild.type = (data.value.value==",valueobject," || data.value.value==",value,") ? Constants.selectKeys.formulaEditor.formulaParamTypes.METRIC_VALUE : Constants.selectKeys.formulaEditor.formulaParamTypes.STRING;
              if(entityToEdit.childs.length>1) {
                let metricChilds = entityToEdit.childs[0];
                let newChilds = [];
                newChilds.push(metricChilds);
                newChilds.push(targetChild);
                if(data.value.value==",valueobject,") {
                  newChilds.push({
                    content: [],
                    type: Constants.selectKeys.formulaEditor.formulaParamTypes.STRING
                  });
                }                
                entityToEdit.childs = newChilds;
              }
            }
            else if(data.value.type == Constants.selectKeys.formulaEditor.formulaParamTypes.STRING) {
              targetChild.content = [data.value.value];
              //special case for attribute function, clean brother
              if(entityToEdit.name == EngineFunctionsDefinition.functionsList.ATTRIBUTE.code && data.index==0 && entityToEdit.childs.length>1) {
                let siblingChild = entityToEdit.childs[1];
                siblingChild.content = []
              }
              if(entityToEdit.name == EngineFunctionsDefinition.functionsList.ATTRIBUTE.code && data.index==0 && data.value.value == Constants.formulaEditor.entities.period && entityToEdit.childs.length<3){
                entityToEdit.childs.push({
                  content: null,
                  type: Constants.selectKeys.formulaEditor.formulaParamTypes.EMPTY    
                })
              }
              else if(entityToEdit.name == EngineFunctionsDefinition.functionsList.ATTRIBUTE.code && data.index==0 && data.value.value != Constants.formulaEditor.entities.period && entityToEdit.childs.length>2) {
                entityToEdit.childs.pop();
              }
            }
            else if(data.value.type == Constants.selectKeys.formulaEditor.formulaParamTypes.ALL || data.value.type == Constants.selectKeys.formulaEditor.systemDimensionParamTypes.ALL_ACTIVE) {
              targetChild.content = [];
            }
            else if(data.value.type == Constants.selectKeys.formulaEditor.formulaParamTypes.EMPTY) {
              targetChild.content = null;
            }
            else if(data.value.type == Constants.selectKeys.formulaEditor.formulaParamTypes.CONTEXT_DIMENSION) {
              let dimensionNode = {};
              dimensionNode.type = "Dimension";
              dimensionNode.name = data.value.value;
              targetChild.content = [dimensionNode];
            }
            else if(data.value.type == Constants.selectKeys.formulaEditor.periodParamExtraType.HISTORIC_PERIODS) {
              let periodQueryNode = {};
              periodQueryNode.type = "PeriodQuery";
              periodQueryNode.period_limit = data.value.value;
              periodQueryNode.ignore_empty = data.value.period_dimension_ignore_empty;
              periodQueryNode.ignore_actual = data.value.period_dimension_ignore_actual;
              periodQueryNode.series = data.value.period_dimension_series;
              targetChild.content = [periodQueryNode];
            }
            if(data.value.param_type != Constants.formulaEditor.functionParamsTypes.metricDimensionsOrValueList) {
              targetChild.type = data.value.type;
            }
            if(entityToEdit.type=="Metric") {
              targetChild.negation = data.value.negation=="true" ? "true" : "false";
            }
          }
        }
        else {          
          entityToEdit[path] = data.value;
          if(entityToEdit.virtual_calculation && path == "calculation_metric_polynomial_name") {
            entityToEdit.childs[Constants.formulaEditor.virtualCalculationMetricPivotPosition] = {
              id: data.pivotDimension ? data.pivotDimension.id : null,
              name: data.pivotDimension ? data.pivotDimension.name : intl.formatMessage({id: "polynomialAdmin.formulaEditor.pivotDimensionEmptyName"}),
              content: null,
              type: ''
            }
            if(data.pivotDimension) {              
              entityToEdit.childs = entityToEdit.childs.filter((dimensionChild, dimensionChildIndex) => (dimensionChildIndex == Constants.formulaEditor.virtualCalculationMetricPivotPosition || dimensionChild.id != data.pivotDimension.id));
            }
          }
        }
      }
      return newFormulaObject;
    }
  },
  changeCollapseEntity: (formulaObject, entityId, forceOpen) => {
    let newFormulaObject = JavascriptUtilsTooling.deepCopy(formulaObject);
    let entityToEdit = FormulaUtilsTooling.getEditingEntity(newFormulaObject, entityId);
    if(entityToEdit) {
      entityToEdit.collapse = forceOpen ? false : !entityToEdit.collapse;
    }
    return newFormulaObject;
  },
  changeCollapseAllEntityRecursive: (formulaArray, collapse) => {
    for(let i=0; i<formulaArray.length; i++) {
      let element = formulaArray[i];
      if(typeof element !== 'string') {        
        if(element.childs) {
          element.collapse = collapse;
          for(let j=0; j<element.childs.length; j++) {
            let element_child = element.childs[j];
            if(element_child.content) {
              FormulaUtilsTooling.changeCollapseAllEntityRecursive(element_child.content, collapse);
            }
          }
        }
      }
    }
  },
  changeCollapseAllEntity: (formulaObject, collapse) => {
    let newFormulaObject = JavascriptUtilsTooling.deepCopy(formulaObject);
    let formulaArray = newFormulaObject.formulaArray;
    let collapseBoolean = collapse=="true" ? true : false;
    FormulaUtilsTooling.changeCollapseAllEntityRecursive(formulaArray, collapseBoolean);
    return newFormulaObject;
  },
  deleteEntity: (formulaObject, entityId) => {
    let newFormulaObject = JavascriptUtilsTooling.deepCopy(formulaObject);
    delete newFormulaObject.invalid
    let entityDeleted = FormulaUtilsTooling.getEditingEntity(newFormulaObject, entityId, true);
    return newFormulaObject;
  },
  getFunctionsList: () => {
    return Object.entries(EngineFunctionsDefinition.functionsList).filter(([key,value]) => !value.deprecated).map(([key, value]) => {
      return {
        id: value.code,
        name: value.label,
        hide: value.hide,
        tooltipDescription: value.tooltipDescription,
      }
    }).sort((a, b) => (a.name > b.name) ? 1 : -1)
  },
  createNewLogicalObject: () => {
    let emptyObject = {};
    emptyObject.type = Constants.formulaEditor.otherObjectTypes.logical;
    emptyObject.comparator = Constants.selectKeys.formulaEditor.logicalComparators.equal;
    emptyObject.is_function = ""
    emptyObject.childs = [];
    emptyObject.childs.push({
      content: [],
      type: Constants.selectKeys.formulaEditor.formulaParamTypes.FREE
    });
    emptyObject.childs.push({
      content: [],
      type: Constants.selectKeys.formulaEditor.formulaParamTypes.FREE
    });
    return emptyObject;
  },
  createNewLogicalDimensionObject: () => {
    let emptyObject = {};
    emptyObject.type = Constants.formulaEditor.otherObjectTypes.logicalDimension;
    emptyObject.comparator = Constants.selectKeys.formulaEditor.logicalComparators.equal;
    emptyObject.is_function = ""
    emptyObject.childs = [];
    emptyObject.childs.push({
      content: [],
      type: Constants.selectKeys.formulaEditor.formulaParamTypes.EMPTY
    });
    emptyObject.childs.push({
      content: [],
      type: Constants.selectKeys.formulaEditor.formulaParamTypes.FREE
    });
    return emptyObject;
  },
  createMark: (formulaObject, segmentObject) => {
    let newFormulaObject = JavascriptUtilsTooling.deepCopy(formulaObject);
    delete newFormulaObject.invalid
    let formulaArray = FormulaUtilsTooling.getFormulaArrayFromParentId(newFormulaObject,segmentObject[0].parentId);
    if(formulaArray==null || segmentObject==null || segmentObject.length!=2) {
      return newFormulaObject;
    }
    let indexStart = segmentObject[0].cursorSide==-1 ? segmentObject[0].index : segmentObject[0].index+1;
    let indexEnd = segmentObject[1].cursorSide==-1 ? segmentObject[1].index-1 : segmentObject[1].index;
    let newMark = {
      childs: [
        {type:Constants.selectKeys.formulaEditor.formulaParamTypes.FREE}
      ],
      collapse: false,
      mark_name: "",
      name: Constants.formulaEditor.markCode,
      type: "Function"
    };
    let deleteElements = formulaArray.splice(indexStart, indexEnd-indexStart+1, newMark);
    newMark.childs[0].content = deleteElements;
    return newFormulaObject;      
  },
  //return the copied segment
  copyFormula: (formulaObject, segmentObject) => {
    let newFormulaObject = JavascriptUtilsTooling.deepCopy(formulaObject);
    let formulaArray = FormulaUtilsTooling.getFormulaArrayFromParentId(newFormulaObject,segmentObject[0].parentId);
    if(formulaArray==null || segmentObject==null || segmentObject.length!=2) {
      return null;
    }
    let indexStart = segmentObject[0].cursorSide==-1 ? segmentObject[0].index : segmentObject[0].index+1;
    let indexEnd = segmentObject[1].cursorSide==-1 ? segmentObject[1].index-1 : segmentObject[1].index;
    return formulaArray.splice(indexStart, indexEnd-indexStart+1);
  },
  deleteFormula: (formulaObject, segmentObject) => {
    let newFormulaObject = JavascriptUtilsTooling.deepCopy(formulaObject);
    delete newFormulaObject.invalid
    let formulaArray = FormulaUtilsTooling.getFormulaArrayFromParentId(newFormulaObject,segmentObject[0].parentId);
    if(formulaArray==null || segmentObject==null || segmentObject.length!=2) {
      return newFormulaObject;
    }
    let indexStart = segmentObject[0].cursorSide==-1 ? segmentObject[0].index : segmentObject[0].index+1;
    let indexEnd = segmentObject[1].cursorSide==-1 ? segmentObject[1].index-1 : segmentObject[1].index;
    formulaArray.splice(indexStart, indexEnd-indexStart+1);
    return newFormulaObject;  
  },
  pasteFormula: (formulaObject, positionObject, formulaToPaste) => {
    let newFormulaObject = JavascriptUtilsTooling.deepCopy(formulaObject);
    delete newFormulaObject.invalid
    let formulaArray = FormulaUtilsTooling.getFormulaArrayFromParentId(newFormulaObject,positionObject.parentId);
    if(formulaArray==null || positionObject==null) {
      return newFormulaObject;
    }
    let indexStart = positionObject.cursorSide==-1 ? positionObject.index : positionObject.index+1;
    formulaArray.splice(indexStart, 0, ...formulaToPaste);
    return newFormulaObject;
  }
};

export default FormulaUtilsTooling;


// WEBPACK FOOTER //
// ./source/tooling/formulaUtilsTooling.js